/**
 * Hybrid Rating Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import React from "react";
import {
  hasStyledProps,
  isStyledExtension,
} from "@sproutsocial/seeds-react-system-props";
import type { TypeRatingProps } from "./RatingTypes";
import RatingContainer from "./styles"; // Styled-components version
import { RatingTailwind, renderRatingItems } from "./RatingTailwind"; // Tailwind version

const RatingHybrid = React.forwardRef<HTMLDivElement, TypeRatingProps>(
  (props, ref) => {
    const { className, ...rest } = props;

    // Rating exposes no styled-system props, so hasStyledProps is effectively
    // always false here; isStyledExtension covers styled(Rating) extensions,
    // which inject a theme/forwardedComponent prop. The extension's generated
    // styles arrive via className, so that is all we forward to the container —
    // RatingContainer has no system-prop mixins, and spreading the remaining
    // rating props onto the div would surface them as invalid DOM attributes.
    if (hasStyledProps(rest) || isStyledExtension(rest)) {
      return (
        <RatingContainer ref={ref} className={className}>
          {renderRatingItems(props)}
        </RatingContainer>
      );
    }

    // Use Tailwind version (preferred - better performance)
    return <RatingTailwind {...props} ref={ref} />;
  }
);

RatingHybrid.displayName = "Rating";
export default RatingHybrid;
